import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserPost } from '../../types/posts';

// Interface for the User
interface IPostState {
	userLikes: string[]
	commentPost: UserPost | undefined
	userPosts: UserPost[]
}

// Initial state
const initialState: IPostState = {
	userLikes: [],
	commentPost: undefined,
	userPosts: []
}

// Slice definition
export const postSlice = createSlice({
	name: 'post',
	initialState,
	reducers: {
		setUserLikes: (state, action: PayloadAction<string[]>) => {
			state.userLikes = action.payload
		},
		setCommentPost: (state, action: PayloadAction<UserPost | undefined>) => {
			state.commentPost = action.payload
		},
		setUserPosts: (state, action: PayloadAction<UserPost[]>) => {
			state.userPosts = action.payload
		}
	}
})

// Export actions
export const { setUserLikes, setCommentPost, setUserPosts } = postSlice.actions

// Export selectors

// Export the reducer
export default postSlice.reducer
